import { render, staticRenderFns } from "./FormStep.vue?vue&type=template&id=1d1c1396"
import script from "./FormStep.vue?vue&type=script&lang=js"
export * from "./FormStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/home/bazzite/Work/awardapplication/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d1c1396')) {
      api.createRecord('1d1c1396', component.options)
    } else {
      api.reload('1d1c1396', component.options)
    }
    module.hot.accept("./FormStep.vue?vue&type=template&id=1d1c1396", function () {
      api.rerender('1d1c1396', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/modules/future_house_awards/components/FormStep.vue"
export default component.exports